import {
  AgentAccountWebService,
  AgentActivityWebService,
  AgentFinanceWebService,
  SupplierAccountWebService
} from '@linktivity/gds-neo';

export * from './bookingWebService/const';

export type AccountbaseStatus = AgentAccountWebService.AccountbaseStatus;
export const AccountbaseStatus = AgentAccountWebService.AccountbaseStatus;
export type Language = AgentAccountWebService.Language;
export const Language = AgentAccountWebService.Language;
export type PartnerCategory = AgentAccountWebService.PartnerCategory;
export const PartnerCategory = AgentAccountWebService.PartnerCategory;
export type CountryCode = AgentAccountWebService.CountryCode;
export const CountryCode = AgentAccountWebService.CountryCode;
export const PrivacyPolicyType = SupplierAccountWebService.PrivacyPolicyType;
export type PrivacyPolicyType = SupplierAccountWebService.PrivacyPolicyType;
export const CurrencyCode = SupplierAccountWebService.CurrencyCode;
export type CurrencyCode = SupplierAccountWebService.CurrencyCode;
export const TransferFeePayer = SupplierAccountWebService.TransferFeePayer;
export type TransferFeePayer = SupplierAccountWebService.TransferFeePayer;
export const BillingMethod = SupplierAccountWebService.BillingMethod;
export type BillingMethod = SupplierAccountWebService.BillingMethod;
export const SystemFeeRefundPolicy =
  SupplierAccountWebService.SystemFeeRefundPolicy;
export type SystemFeeRefundPolicy =
  SupplierAccountWebService.SystemFeeRefundPolicy;
export const SuppliersStatus =
  SupplierAccountWebService.ListSuppliersWithPageStatusEnum;
export type SuppliersStatus =
  SupplierAccountWebService.ListSuppliersWithPageStatusEnum;

export const ContractOwner = SupplierAccountWebService.ContractOwner;

export const AccountRole = SupplierAccountWebService.Role;
export type AccountRole = SupplierAccountWebService.Role;
export type NotificationType = AgentAccountWebService.NotificationResourceType;
export const NotificationType = AgentAccountWebService.NotificationResourceType;
export type NotificationMethod = AgentAccountWebService.NotificationMethod;
export const NotificationMethod = AgentAccountWebService.NotificationMethod;

export const ContractType = AgentAccountWebService.ContractType;
export type ContractType = AgentAccountWebService.ContractType;
export const PaymentType = AgentAccountWebService.PaymentType;
export type PaymentType = AgentAccountWebService.PaymentType;
export const AgentStatus = AgentAccountWebService.AccountbaseStatus;
export type AgentStatus = AgentAccountWebService.AccountbaseStatus;
export const PaymentPeriod = AgentAccountWebService.PaymentPeriod;
export type PaymentPeriod = AgentAccountWebService.PaymentPeriod;
export type Role = AgentAccountWebService.Role;
export const Role = AgentAccountWebService.Role;
export type ExtendedBookingFieldId =
  AgentActivityWebService.ExtendedBookingFieldId;
export const ExtendedBookingFieldId =
  AgentActivityWebService.ExtendedBookingFieldId;
export type BookingFieldId = AgentActivityWebService.BookingFieldId;
export const BookingFieldId = AgentActivityWebService.BookingFieldId;

export type CheckListItemType = AgentActivityWebService.CheckListItemType;
export const CheckListItemType = AgentActivityWebService.CheckListItemType;

export type VoucherExpirationPeriodType =
  AgentActivityWebService.VoucherExpirationPeriodType;
export const VoucherExpirationPeriodType =
  AgentActivityWebService.VoucherExpirationPeriodType;
export type PeriodUnit = AgentActivityWebService.PeriodUnit;
export const PeriodUnit = AgentActivityWebService.PeriodUnit;

export type ExtendedParticipantFieldId =
  AgentActivityWebService.ExtendedParticipantFieldId;

export const ExtendedParticipantFieldId =
  AgentActivityWebService.ExtendedParticipantFieldId;

export const WalletOrderStatus = AgentFinanceWebService.WalletOrderStatus;
export type WalletOrderStatus = AgentFinanceWebService.WalletOrderStatus;

export const TransactionTypeMap =
  AgentFinanceWebService.ListBookingTransactionsWithPageTransactionTypeEnum;
export type TransactionTypeMap =
  AgentFinanceWebService.ListBookingTransactionsWithPageTransactionTypeEnum;

export const languageText: Partial<Record<Language, string>> = {
  [Language.Japanese]: 'ja',
  [Language.English]: 'en',
  [Language.SimplifiedChinese]: 'zh',
  [Language.TraditionalChinese]: 'zt',
  [Language.Korean]: 'ko'
};

export const textLanguage: Partial<Record<string, Language>> = {
  ja: Language.Japanese,
  en: Language.English,
  zh: Language.SimplifiedChinese,
  zt: Language.TraditionalChinese,
  ko: Language.Korean
};

export const JapanPrefecture = {
  Hokkaido: 'hokkaido',
  Aomori: 'aomori',
  Iwate: 'iwate',
  Miyagi: 'miyagi',
  Akita: 'akita',
  Yamagata: 'yamagata',
  Fukushima: 'fukushima',
  Ibaraki: 'ibaraki',
  Tochigi: 'tochigi',
  Gunma: 'gunma',
  Saitama: 'saitama',
  Chiba: 'chiba',
  Tokyo: 'tokyo',
  Kanagawa: 'kanagawa',
  Niigata: 'niigata',
  Toyama: 'toyama',
  Ishikawa: 'ishikawa',
  Fukui: 'fukui',
  Yamanashi: 'yamanashi',
  Nagano: 'nagano',
  Gifu: 'gifu',
  Shizuoka: 'shizuoka',
  Aichi: 'aichi',
  Mie: 'mie',
  Shiga: 'shiga',
  Kyoto: 'kyoto',
  Osaka: 'osaka',
  Hyogo: 'hyogo',
  Nara: 'nara',
  Wakayama: 'wakayama',
  Tottori: 'tottori',
  Shimane: 'shimane',
  Okayama: 'okayama',
  Hiroshima: 'hiroshima',
  Yamaguchi: 'yamaguchi',
  Tokushima: 'tokushima',
  Kagawa: 'kagawa',
  Ehime: 'ehime',
  Kochi: 'kochi',
  Fukuoka: 'fukuoka',
  Saga: 'saga',
  Nagasaki: 'nagasaki',
  Kumamoto: 'kumamoto',
  Oita: 'oita',
  Miyazaki: 'miyazaki',
  Kagoshima: 'kagoshima',
  Okinawa: 'okinawa'
};
